// relative
import { apiSlice } from '../../apiSlice';

export const dataApiSlice = apiSlice.injectEndpoints({
  tagTypes: ['DataSeries'],
  endpoints: (builder) => ({
    getData: builder.query({
      query: (args) => {
        const { from, to, unitId, datatype, unitTypeInputId, aggregateType } =
          args;
        return {
          url: `/Data?orderby=Timestamp&Timestamp=ge(${from})&Timestamp=lt(${to})&UnitId=eq(${unitId})&AggregateType=eq(${aggregateType})&DataType=eq(${datatype})&UnitTypeInputId=eq(${unitTypeInputId})&top=10000`,
        };
      },
      providesTags: ['DataSeries'],
      keepUnusedDataFor: 5, //This is the caching mechanism keeps the data for 5 seconds - default is 60
    }),
  }),
});

export const { useGetDataQuery, useLazyGetDataQuery } = dataApiSlice;
